import { AlertService } from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { OnInit } from '@angular/core';
import { QuestionSetLabel } from '../../shared/models/question-set-label';
import { AssessmentService } from '../../shared/services/assessment.service';
import { Router, ActivatedRoute } from '@angular/router';
var LabelNewComponent = /** @class */ (function () {
    function LabelNewComponent(assessmentService, alertService, location, router, route) {
        this.assessmentService = assessmentService;
        this.alertService = alertService;
        this.location = location;
        this.router = router;
        this.route = route;
        this.SAVE_TIME = 1500;
        this.ERROR_MESSAGE_TIME = 3000;
        this.label = this.getNewObject();
    }
    LabelNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var setId = params['setId'];
            _this.assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
                _this.questionSet = assessment.question_sets.find(function (s) { return s.id == setId; });
                if (!_this.questionSet) {
                    // TODO: stephen should we navigate back?? or do some kind of 404?
                    _this.router.navigate(["not-found"]);
                }
            })
                .catch(function (error) {
                console.error(error);
                _this.router.navigate(["not-found"]);
            });
        });
    };
    LabelNewComponent.prototype.getNewObject = function () {
        var label = new QuestionSetLabel();
        label.id = this.assessmentService.newId();
        return label;
    };
    Object.defineProperty(LabelNewComponent.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (v) {
            this._label = v;
        },
        enumerable: true,
        configurable: true
    });
    LabelNewComponent.prototype.goBack = function () {
        this.location.back();
    };
    LabelNewComponent.prototype.saveLabel = function (label) {
        var _this = this;
        this.questionSet.addLabel(label);
        this.isSaving = true;
        return this.assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Label saved", _this.SAVE_TIME);
            _this.isSaving = false;
            return label;
        }).catch(function (error) {
            _this.isSaving = false;
            _this.alertService.error("An error occurred in saving. Please try again or contact support.", _this.ERROR_MESSAGE_TIME);
            console.error(error);
        });
    };
    LabelNewComponent.prototype.save = function () {
        var _this = this;
        this.saveLabel(this.label).then(function (question) {
            setTimeout(function () {
                _this.router.navigate(["../", _this.label.id, "edit"], { relativeTo: _this.route, replaceUrl: true });
            }, _this.SAVE_TIME);
        });
    };
    LabelNewComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this.saveLabel(this.label).then(function (question) {
            _this.label = _this.getNewObject();
        });
    };
    return LabelNewComponent;
}());
export { LabelNewComponent };



// WEBPACK FOOTER //
// ./src/app/admin/label-new/label-new.component.ts.pre-build-optimizer.js